import { CardActionArea, CardContent, Stack, Typography, useTheme, Tooltip } from "@mui/material";
import { MprcCard } from "components";
import { Formaters } from "lib/Formaters";
import React from "react";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export interface IProps {
    value: number;
    isPercent?: boolean;
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    active?: boolean;
    color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
    tooltipText?: string;
    onClick?: () => void;
}

export const DASH_SQUARE_CARD_WIDTH = 190;
export const DASH_SQUARE_CARD_HEIGHT = 170;

export const DashSquareCardCustomSelect: React.FC<IProps> = ({ value, isPercent, title, subtitle, active, color, tooltipText, onClick }) => {

    const theme = useTheme();

    return (
        <MprcCard sx={{ width: DASH_SQUARE_CARD_WIDTH, height: DASH_SQUARE_CARD_HEIGHT }}>
            <CardActionArea
                onClick={onClick}
                data-active={active ? '' : undefined}
                sx={{
                    height: '100%',
                    '&[data-active]': {
                        backgroundColor: theme.palette.notice.light,
                        '&:hover': {
                            backgroundColor: 'action.selectedHover',
                        },
                    },
                }}
            >
                <CardContent>
                    <Stack alignItems="center" justifyContent="center" spacing={2}>
                        <Typography variant="h1" component="div" fontSize={64} color={color ? color : "muted.main"}>
                            {Formaters.localeNumber(value)}{isPercent && "%"}
                        </Typography>
                        {title &&
                            <>
                                <Stack direction="row" alignItems="center" justifyContent="center" height={20} spacing={1}>
                                    <Typography
                                        width={140}
                                        component="div"
                                        fontSize={14}
                                        lineHeight="normal"
                                        color="muted.main"
                                        textTransform="uppercase"
                                        fontWeight="bold"
                                        align="center"
                                    >
                                        {title}
                                    </Typography>
                                    <Tooltip title={tooltipText}>
                                        <span>
                                            <InfoOutlinedIcon sx={{ color: 'muted.main', backgroundColor: 'common.white', borderRadius: '50%' }} />
                                        </span>
                                    </Tooltip>
                                </Stack>
                                    <Stack direction="row" alignItems="center" justifyContent="center" height={10} spacing={1}>
                                        <Typography variant="body2" color="error" textTransform="uppercase" fontWeight="bold">
                                            {subtitle ? `(${subtitle})` : null}
                                        </Typography>
                                    </Stack>
                            </>
                        }
                    </Stack>
                </CardContent>
            </CardActionArea>
        </MprcCard>
    );
};
